
import { combineReducers } from 'redux';
import snackbar from './snackbar';

const reducers = combineReducers({
    snackbar,
  });
  
  export default reducers;